import { render, staticRenderFns } from "./ProgressBarDetails.vue?vue&type=template&id=bf079a54&scoped=true&"
import script from "./ProgressBarDetails.vue?vue&type=script&lang=js&"
export * from "./ProgressBarDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProgressBarDetails.vue?vue&type=style&index=0&id=bf079a54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf079a54",
  null
  
)

export default component.exports